<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { addListener, launch } from "devtools-detector";

export default {
  data() {
    return {};
  },
  mounted() {
    // 1. 添加一个监听器，当控制台状态变化时会被调用
    addListener((isOpen) => {
      if (isOpen) {
        console.log("⚠️ 开发者工具已打开！");
        window.location.reload();
      } else {
        console.log("✅ 开发者工具已关闭");
      }
    });
    launch();

  },
};
</script>

<style lang="less">
/*滚动条设置*/
::-webkit-scrollbar {
  width: 0px;
}

::-webkit-scrollbar-track {
  background: #041954;
}

::-webkit-scrollbar-thumb {
  background: #041954;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box; // 自适应核心
  user-select: none !important; /* 禁止所有元素被选中、不显示光标 */
}

// html + body 全屏
html,
body {
  width: 100%;
  height: 100%;
  background-color: #041954; // 你要的深蓝色背景
  overflow: hidden; // 禁止全局滚动条
}

// 根容器 100% 自适应
#app {
  width: 100%;
  height: 100vh; // 自适应屏幕高度
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
